export const validate = Symbol('validate');

const dispatchIfExists = (store, action) => {
  if (!action) return null;
  return store.dispatch(action);
};

export default store => next => action => {
  if (action[validate] === undefined) {
    return next(action);
  }
  const valid = action[validate].validator(store);
  dispatchIfExists(store, action[validate].always);
  if (valid) {
    return dispatchIfExists(store, action[validate].success);
  }
  return dispatchIfExists(store, action[validate].fail);
};

export const notEmptyString = val => typeof val === 'string' && val.length > 0;

export const maxLengthValid = (val, maxLen) => typeof val === 'string' && val.length <= maxLen;

// Allows letters, numbers, spaces, `-` and `,`
const ADDRESS_LINE_REGEX = /^[0-9A-Za-z\s\-,.']+$/;
export const isValidAddressLine = (val) => ADDRESS_LINE_REGEX.test(val);